export default {
      id: "phone-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite.svg#phone",
      toString: function () {
        return this.url;
      }
    }